// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b3225ae8","453":"540ba027","455":"b41e3666","977":"4f25b853"}[chunkId] + ".chunk.js";
};